import { setRooftop, setCustomerConfig } from '@store';
import { Customers } from '@gql/base-types';

/**
 * The one way the active rooftop changes — extracted from HeaderRooftopSelect
 * so programmatic switches (e.g. search's switch-on-click) behave exactly like
 * picking the rooftop in the header. Persists to localStorage `rooftopId`,
 * which is also the next-login default rooftop — deliberate, so an automatic
 * switch and a manual one leave the app in the same state.
 */
export function applyRooftopSwitch(rooftop?: Customers): void {
  const selectedRooftopId = rooftop?.id || 0;
  localStorage?.setItem(`rooftopId`, JSON.stringify(selectedRooftopId));
  setRooftop(rooftop);

  if (!rooftop) return;

  // Read the DB-computed effective_config off the selected rooftop.
  if (rooftop.effective_config) {
    setCustomerConfig(rooftop.effective_config);
  }
}
